module.exports = __webpack_public_path__ + "img/datacener_pic_erdos.395b21d6.jpg";